@import 'styles/mixins';

.lockButtonContainer {
  @include transition;
  opacity: 0;
  pointer-events: none;

  @include for-phone-only {
    opacity: 1;
    pointer-events: all;
  }

  &.visible {
    opacity: 1;
    pointer-events: all;
  }
}
